export const initAccordion = () => {
	const accordionElements = document.querySelectorAll(".accordion");

	// --- Auto-expand accordions based on query params ---
	const params = new URLSearchParams(window.location.search);
	params.forEach((value, key) => {
		// Remove leading underscore if present
		const id = key.startsWith("_") ? key.slice(1) : key;
		const accordion = document.getElementById(id);
		if (accordion) {
			const header = accordion.querySelector(".header");
			const body = accordion.querySelector(".body");
			if (header && body) {
				header.classList.add("active");
				body.style.maxHeight = body.scrollHeight + "px";
			}
		}
	});

	// --- Click-to-toggle functionality ---
	accordionElements.forEach((accordion) => {
		const header = accordion.querySelector(".header");
		const body = accordion.querySelector(".body");
		if (!header || !body) return;

		header.addEventListener("click", () => {
			const isActive = header.classList.contains("active");

			if (!isActive) {
				header.classList.add("active");
				body.style.maxHeight = body.scrollHeight + "px";
			} else {
				header.classList.remove("active");
				body.style.maxHeight = null;
			}
		});
	});
};
